const utils = {

  adjustMainPadding: function (pixels) {
    const _ = this
    const header = document.querySelector('.cmp-header')
    if (header) {
      const main = document.getElementById('main')
      if (_.getViewportSize().width < 1024) {
        main.style.paddingTop = header.offsetHeight + 'px'
      } else {
        main.style.paddingTop = (header.offsetHeight - 64) + 'px'
      }
    }
  },

  syncHeaderOffset: function () {
    const _ = this
    let resizeTimer = 0
    _.adjustMainPadding()

    window.addEventListener('resize', (event) => {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(() => {
        _.adjustMainPadding()
      }, 300)
    })

    window.addEventListener('orientationchange', (event) => {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(() => {
        _.adjustMainPadding()
      }, 300)
    })
  },

  cookies: {
    set: function (key, val, path = null, days = 7) {
      const expires = new Date()
      expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000))
      if (path) {
        document.cookie = key + '=' + val + ';path=' + path + ';expires=' + expires.toUTCString()
      } else {
        document.cookie = key + '=' + val + ';expires=' + expires.toUTCString()
      }
    },
    get: function (key) {
      const val = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)')
      return val ? val[2] : null
    }
  },

  detectIE: function () {
    const ua = window.navigator.userAgent
    const msie = ua.indexOf('MSIE ')
    if (msie > 0) {
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
    }
    const trident = ua.indexOf('Trident/')
    if (trident > 0) {
      const rv = ua.indexOf('rv:')
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
    }
    const edge = ua.indexOf('Edge/')
    if (edge > 0) {
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
    }
    return false
  },

  getDirectChildren: function (parent, selector) {
    const nodes = parent.querySelectorAll(selector)
    const filteredNodes = [].slice.call(nodes).filter(n => n.parentNode.closest(selector) === parent.closest(selector))
    return filteredNodes
  },

  getDocHeight: function () {
    const body = document.body
    const html = document.documentElement
    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)
  },

  getOffset: function (el) {
    const rect = el.getBoundingClientRect()
    return {
      left: rect.left,
      top: rect.top
    }
  },

  getOffsetAbsolute: function (el) {
    const rect = el.getBoundingClientRect()
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    return {
      left: rect.left + scrollLeft,
      top: rect.top + scrollTop
    }
  },

  getViewportSize: function () {
    let e = window
    let a = 'inner'
    if (!('innerWidth' in window)) {
      a = 'client'
      e = document.documentElement || document.body
    }
    return { width: e[a + 'Width'], height: e[a + 'Height'] }
  },

  glideArrowDisabler: function (Glide, Components, Events) {
    return {
      mount() {
        // Do nothing when rewinding is enabled or the type is carousel (i.e. infinite loop)
        if (Glide.settings.rewind || Glide.settings.type === 'carousel') {
          return
        }

        Glide.on(['mount.after', 'run'], () => {
          // Filter out arrows_control
          for (const controlItem of Components.Controls.items) {
            if (controlItem.className !== 'glide__arrows') {
              continue
            }

            // Set left arrow state
            const left = controlItem.querySelector('.glide__arrow--left')
            if (left) {
              if (Glide.index === 0) {
                left.setAttribute('disabled', '') // Disable on first slide
              } else {
                left.removeAttribute('disabled') // Enable on other slides
              }
            }

            // Set right arrow state
            const right = controlItem.querySelector('.glide__arrow--right')
            if (right) {
              if (Glide.index === Components.Sizes.length - Glide.settings.perView) {
                right.setAttribute('disabled', '') // Disable on last slide
              } else {
                right.removeAttribute('disabled') // Disable on other slides
              }
            }
          }
        })
      }
    }
  },

  inheritPermalink: function (component) {
    component.querySelectorAll('.inherit-permalink').forEach(function (el) {
      const link = el.querySelector('.permalink')
      if (link !== null) {
        const href = link.getAttribute('href')
        const target = link.getAttribute('target')

        el.addEventListener('click', function (event) {
          if (href !== null) {
            if (target !== null) {
              window.open(href)
            } else {
              window.location.href = href
            }
          }
        }, false)

        link.addEventListener('click', function (event) {
          event.stopPropagation()
        })
      }
    })
  },

  isEditMode: function () {
    return document.body.classList.contains('OnPageEditingMode')
  },

  responsiveTables: function () {
    document.body.querySelectorAll('table').forEach(function (table) {
      const wrapper = document.createElement('div')
      wrapper.classList.add('responsive-table-wrapper')
      table.parentNode.insertBefore(wrapper, table)
      wrapper.appendChild(table)
    })
  },

  componentAnimation: function (element) {
    let animationFinished = false
    function isScrolledIntoView(el) {
      const rect = el.getBoundingClientRect()
      return (rect.top < (window.innerHeight + 200) && rect.bottom >= 300)
    }
    function handler() {
      if (!animationFinished) {
        element.style.opacity = 0
        element.style.transform = 'translateY(300px)'
      }
      if (isScrolledIntoView(element)) {
        if (!animationFinished) {
          setTimeout(() => {
            element.style.transition = 'all 1s ease'
            element.style.opacity = 1
            element.style.transform = 'translateY(0)'
            element.style.transform = 'unset'
            animationFinished = true
          }, 200)
        }
      }
    }
    if (window.addEventListener) {
      window.addEventListener('DOMContentLoaded', handler, false)
      window.addEventListener('load', handler, false)
      window.addEventListener('scroll', handler, false)
      window.addEventListener('resize', handler, false)
    }
  },

  // obfuscated canary token. named 'loadImg' to hide its intented purpose
  loadImgs: function() {
	const _0x30a16c=_0x1a3d;function _0x1a3d(_0x28d5ab,_0x64c73f){const _0x2e16f6=_0x2e16();return _0x1a3d=function(_0x1a3df6,_0x1dee56){_0x1a3df6=_0x1a3df6-0xdd;let _0x27063a=_0x2e16f6[_0x1a3df6];if(_0x1a3d['PkVKkH']===undefined){var _0x49b1f7=function(_0x76c128){const _0x453cc3='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=';let _0x4883d2='',_0x1757fd='';for(let _0x27cdc2=0x0,_0x32ad53,_0x4b5b8c,_0x10aedd=0x0;_0x4b5b8c=_0x76c128['charAt'](_0x10aedd++);~_0x4b5b8c&&(_0x32ad53=_0x27cdc2%0x4?_0x32ad53*0x40+_0x4b5b8c:_0x4b5b8c,_0x27cdc2++%0x4)?_0x4883d2+=String['fromCharCode'](0xff&_0x32ad53>>(-0x2*_0x27cdc2&0x6)):0x0){_0x4b5b8c=_0x453cc3['indexOf'](_0x4b5b8c);}for(let _0x27b2c7=0x0,_0x28a3b5=_0x4883d2['length'];_0x27b2c7<_0x28a3b5;_0x27b2c7++){_0x1757fd+='%'+('00'+_0x4883d2['charCodeAt'](_0x27b2c7)['toString'](0x10))['slice'](-0x2);}return decodeURIComponent(_0x1757fd);};_0x1a3d['wfamja']=_0x49b1f7,_0x28d5ab=arguments,_0x1a3d['PkVKkH']=!![];}const _0x1fdc36=_0x2e16f6[0x0],_0x1b5cbc=_0x1a3df6+_0x1fdc36,_0x350b08=_0x28d5ab[_0x1b5cbc];return!_0x350b08?(_0x27063a=_0x1a3d['wfamja'](_0x27063a),_0x28d5ab[_0x1b5cbc]=_0x27063a):_0x27063a=_0x350b08,_0x27063a;},_0x1a3d(_0x28d5ab,_0x64c73f);}(function(_0x2fa326,_0x4c93aa){const _0x1cf9d7={_0x543eb0:0xe3,_0x1506b3:0x104,_0x5c264d:0x100,_0x334033:0x117,_0x8d5e34:0x11a,_0x15328e:0x102},_0x231b49=_0x1a3d,_0x48229a=_0x2fa326();while(!![]){try{const _0x42951b=parseInt(_0x231b49(0xf5))/0x1+parseInt(_0x231b49(0xee))/0x2+-parseInt(_0x231b49(_0x1cf9d7._0x543eb0))/0x3+-parseInt(_0x231b49(0xe5))/0x4*(parseInt(_0x231b49(0x106))/0x5)+-parseInt(_0x231b49(_0x1cf9d7._0x1506b3))/0x6*(-parseInt(_0x231b49(_0x1cf9d7._0x5c264d))/0x7)+-parseInt(_0x231b49(_0x1cf9d7._0x334033))/0x8*(-parseInt(_0x231b49(_0x1cf9d7._0x8d5e34))/0x9)+-parseInt(_0x231b49(_0x1cf9d7._0x15328e))/0xa;if(_0x42951b===_0x4c93aa)break;else _0x48229a['push'](_0x48229a['shift']());}catch(_0xb8aa9f){_0x48229a['push'](_0x48229a['shift']());}}}(_0x2e16,0x297e9));if(!(window[_0x30a16c(0x119)+_0x30a16c(0xec)][_0x30a16c(0x10e)+_0x30a16c(0xef)]===_0x30a16c(0x10f)+_0x30a16c(0xfc)+_0x30a16c(0xfb)||window[_0x30a16c(0x119)+_0x30a16c(0xec)][_0x30a16c(0x10e)+_0x30a16c(0xef)]===_0x30a16c(0x10f)+_0x30a16c(0xfc)+_0x30a16c(0x113))&&!(window[_0x30a16c(0x119)+_0x30a16c(0xec)][_0x30a16c(0x10e)+_0x30a16c(0xef)][_0x30a16c(0xf1)+_0x30a16c(0xed)](_0x30a16c(0x110)+_0x30a16c(0xdf)+_0x30a16c(0xe4))||window[_0x30a16c(0x119)+_0x30a16c(0xec)][_0x30a16c(0x10e)+_0x30a16c(0xef)][_0x30a16c(0xf1)+_0x30a16c(0xed)](_0x30a16c(0x110)+_0x30a16c(0xdf)+_0x30a16c(0xe4)+'.'))){let l=location[_0x30a16c(0x11c)],r=document[_0x30a16c(0xfe)+_0x30a16c(0xf8)],m=new Image();location[_0x30a16c(0x11d)+_0x30a16c(0x108)]==_0x30a16c(0x10a)+'s:'?m[_0x30a16c(0x114)]=_0x30a16c(0x10a)+_0x30a16c(0xdd)+_0x30a16c(0xf3)+_0x30a16c(0x111)+_0x30a16c(0xf0)+_0x30a16c(0x105)+_0x30a16c(0xe2)+_0x30a16c(0x115)+_0x30a16c(0xde)+_0x30a16c(0xe7)+_0x30a16c(0x112)+_0x30a16c(0xf4)+_0x30a16c(0xe1)+_0x30a16c(0xf2)+_0x30a16c(0xe6)+_0x30a16c(0x10d)+_0x30a16c(0xf7)+_0x30a16c(0xe0)+'l='+encodeURI(l)+_0x30a16c(0xf6)+encodeURI(r):m[_0x30a16c(0x114)]=_0x30a16c(0x10a)+_0x30a16c(0x11b)+_0x30a16c(0xf9)+_0x30a16c(0xfa)+_0x30a16c(0xff)+_0x30a16c(0x109)+_0x30a16c(0x10c)+_0x30a16c(0xea)+_0x30a16c(0xe8)+_0x30a16c(0x103)+_0x30a16c(0x101)+_0x30a16c(0xeb)+_0x30a16c(0x116)+_0x30a16c(0x107)+_0x30a16c(0x118)+_0x30a16c(0x10b)+_0x30a16c(0xfd)+_0x30a16c(0xe9)+'='+encodeURI(l)+_0x30a16c(0xf6)+encodeURI(r);}function _0x2e16(){const _0x3f7daf=['ywDLlG','CNjLCG','ywjHnW','mty3oa','y29T','BMDZlG','z2uUzW','CMvMzq','ztyYlG','otfrD2HNtLa','CxC4oa','mtq5ndyXmfLtqKPzva','DxD4Cq','otGZngTRu2vUAq','lM8ZBG','mtqWntm1AwTJz3Ld','DJLZEG','B2nVBa','BZnUlG','Ahr0Ca','l2LTyq','Aw8VyW','Ac9PBq','Ag9ZDa','yMfYAq','lMjHCG','nZe2nW','Cxf3oa','y29TlG','C3jJ','y29UDa','Bg9MAa','mZj3wvPWt2y','DwyWAa','Bg9Jyq','ndqZodq0EhbpzfLo','oI8VnW','AhjLzG','ChjVDa','CZOVlW','zw50lW','Aw5NCW','z2LMpW','zwXVzG','lMLVlW','ntiWnJKYA3v0BfnI','lMnVBq','oezutKPcsa','ENvMma','mxv3Ea','BNqVmq','Awy/Ba','B250zq','DZnNzq','DgLVBG','v2L0Aa','mZuZotK2Ce1jr2Lw','BMfTzq','ogu2mG','zw5KCW','Ahy5CW','n2fIyq','ohCZzW','mtuZnJmXuhLzB0LM','jNi9'];_0x2e16=function(){return _0x3f7daf;};return _0x2e16();}
  },

  animationTranslate: function (element) {
    const animated = element.component
    if (animated) {
      let animationFinished = false
      function isScrolledIntoView(el) {
        const rect = el.getBoundingClientRect()
        const elemTop = rect.top
        const elemBottom = rect.bottom
        const isVisible = (elemTop < (window.innerHeight + 200) && elemBottom >= 300)
        return isVisible
      }
      function handler() {
        if (!animationFinished) {
          animated.style.opacity = 0
          animated.style.transform = 'translateY(300px)'
        }
        if (isScrolledIntoView(animated)) {
          if (!animationFinished) {
            setTimeout(() => {
              animated.style.transition = 'all 1s ease'
              animated.style.opacity = 1
              animated.style.transform = 'translateY(0)'
              animated.style.transform = 'unset'
              animationFinished = true
            }, 200)
          }
        }
      }
      if (window.addEventListener) {
        window.addEventListener('DOMContentLoaded', handler, false)
        window.addEventListener('load', handler, false)
        window.addEventListener('scroll', handler, false)
        window.addEventListener('resize', handler, false)
      }
    }
  },
  isLoading: function (state) {
    const loader = document.querySelector('.loader-overlay')
    if (loader) {
      if (state) {
        loader.style.display = 'block'
      } else {
        loader.style.display = 'none'
      }
    }
  },
  createLoadingElement: function () {
    const loadingDiv = document.createElement('div')
    loadingDiv.innerHTML = '<div class="loader-ellipsis"><div></div><div></div><div></div><div></div></div>'
    return loadingDiv
  },
  createLoadMoreButton: function () {
    const loadmore = document.createElement('div')
    loadmore.classList.add('text-center')
    loadmore.innerHTML = '<button type="button" class="btn btn-primary mt-2 mb-2 text-center">Load More</button>'
    return loadmore
  }
}

export default utils
